// Modules
import Head from "next/head";
import { SessionProvider } from "next-auth/react";
import { Provider as ReduxProvider } from "react-redux";
import PropTypes from "prop-types";
// Store
import { store } from "../config/store";
// Components
import { Auth } from "../components";
import { Snackbar, Spinner } from "../components/UITemplate";
import { GlobalModalHost } from "@/components/Patient/components/GlobalModalHost";
import { AppIntegrationScripts } from "../components/Config/IntegrationScripts";
// Styles
import "../styles/sass/main.scss";
import "../components/UITemplate/styles/scss/style.scss";

function MyApp({ Component, pageProps: { session, ...pageProps } }) {
    return (
        <>
            <Head>
                <title>WORTHELDEN - Dashboard</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no"
                />
            </Head>

            {process.env.NEXT_PUBLIC_ENV === "production" && <AppIntegrationScripts />}

            <SessionProvider session={session} refetchInterval={5 * 1000}>
                <ReduxProvider store={store}>
                    <Auth authProps={Component.auth}>
                        <Component {...pageProps} />
                        <Snackbar />
                        <Spinner />
                        <GlobalModalHost />
                    </Auth>
                </ReduxProvider>
            </SessionProvider>
        </>
    );
}

MyApp.propTypes = {
    Component: PropTypes.func,
    pageProps: PropTypes.object
};

export default MyApp;
